import type { FieldMessage } from 'apiConnector/secondary-market/batch/base';
import { ApiLevel } from 'utils/http/httpClient.model';

export const levelPriority: Record<ApiLevel, number> = {
  Critical: 4,
  Error: 3,
  Warning: 2,
  Info: 1,
};
export function getHigherLevel(validations?: FieldMessage[]) {
  return validations?.sort(
    (a, b) => (levelPriority[b.level ?? 'Error'] ?? 0) - (levelPriority[a.level ?? 'Error'] ?? 0),
  )[0]?.level;
}
